import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, border, font } = baseVariables;

export const StyledPickupStatsCard = styled.div`
  background-color: ${color.base20};
  box-shadow: 0 ${toRem(2)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);
  border-radius: ${toRem(16)};
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  .image-section {
    position: relative;
    width: 100%;
    max-height: ${toRem(204)};

    .property-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .alert-badge {
      position: absolute;
      top: ${toRem(26)};
      left: ${toRem(17)};
      color: ${color.base10};
      padding: ${toRem(4)} ${toRem(8)};
      font-weight: ${font.fontWeightMedium};
    }
  }

  .card-body {
    flex: 1;
    .card-details {
      .separator {
        color: ${color.neutral30};
      }
      .icon {
        color: ${color.neutral40};
      }
      .dates,
      .rooms {
        color: ${color.base10};
      }
    }
  }

  .pickup-progress {
    &-count {
      display: block;
      color: ${color.neutral40};
    }

    &-track {
      width: 100%;
      height: ${toRem(16)};
      background-color: ${color.neutral20};
      border-radius: ${toRem(14)};
      overflow: hidden;
    }
  }

  .card-footer {
    padding: ${toRem(10)} ${toRem(16)};
    border-top: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};

    .footer-cta {
      font-size: ${toRem(13)};
      border-bottom: none;
      font-weight: ${font.fontWeightMedium};
      background: none;

      &:focus-visible {
        outline: -webkit-focus-ring-color auto ${toRem(1)};
      }
    }
  }
`;

export const StyledProgressFill = styled.div<{ $fillWidth: number }>`
  height: 100%;
  width: ${({ $fillWidth }) => $fillWidth}%;
  background: #326ded;
  border-radius: ${toRem(14)};
`;
